let limitedFilters;

export const config = {
    HotelsByStar: { sorter: sorter('name', 'desc'), limit: 10 },
    HotelsByPropertyType: { sorter: sorter('count', 'desc'), limit: 5 },
    HotelsByBoardType: { sorter: sorter('title', 'asc'), limit: 6 },
    HotelsByChildDestination: { sorter: sorter('count', 'desc'), limit: 5 }
};

function configFacilities(agg) {
    limitedFilters = ['HotelsByStar', 'HotelsByPropertyType', 'HotelsByBoardType', 'HotelsByChildDestination'];
    for (const group in agg.HotelsByFacility) {
        agg[group] = agg.HotelsByFacility[group];
        limitedFilters.push(group);
        config[group] = { sorter: sorter('title'), limit: 5 };
    }
}

export function getFilterLimits() {
    const limits = {};
    limitedFilters.forEach(function(f) {
        limits[f] = config[f].limit;
    });
    return limits;
}

function sorter(prop, dir) {
    const multi = dir === 'desc' ? -1 : 1;
    return function compare(a, b) {
        return multi * (a[prop] < b[prop] ? -1 : (a[prop] > b[prop] ? 1 : 0));
    };
}

function arrayifyAggregates(dict) {
    for (let i = 0; i < limitedFilters.length; i++) {
        const prop = limitedFilters[i];
        if (dict[`${prop}Array`]) {
            continue;
        }
        const arr = [];
        for (const p in dict[prop]) {
            if (dict[prop].hasOwnProperty(p)) {
                arr.push({
                    name: p,
                    title: dict[prop][p].Title,
                    count: dict[prop][p].Count != null ? dict[prop][p].Count : dict[prop][p],
                    minPrice: dict[prop][p].MinPrice,
                    cheapest: false
                });
            }
        }
        dict[`${prop}Array`] = arr.sort(config[prop].sorter);

        // flag the cheapest
        const filtered = _.filter(dict[`${prop}Array`], function(f) {
            return f.count > 0;
        });
        const min = _.minBy(filtered, function(x) {
            return x.minPrice;
        });
        if (_.isObject(min)) {
            min.cheapest = true;
        }
    }
}

export function enhanceAggregates(aggregates) {
    configFacilities(aggregates);
    arrayifyAggregates(aggregates);
    return aggregates;
}
